import React, { useEffect, useState } from 'react';
import BbsViewComponent from '../common/bbs/BbsViewComponent';
import { withRouter, Link } from 'react-router-dom';
import queryString from 'query-string';
import * as BbsService from '../../../services/Bbs.service';
import * as ListHelper from '../../../helpers/List.helper';
import stripHtml from 'string-strip-html';

const NewsViewContainer = props => {

    const [info, setInfo] = useState(null);

    useEffect(_ => {
        const init = async id => {
            let info = await BbsService.getInfo(id);
            setInfo(info);
        }
        init(props.match.params.id);
    }, []);

    const onClickBtnList = evt => {
        props.history.goBack();
    }
    return (
        <BbsViewComponent
            info={info}
            onClickBtnList={onClickBtnList}
            {...props} />
    )
}
export default withRouter(NewsViewContainer);